import * as t from "io-ts";
import { decimal } from "./index";
export const CargoExtraCo2BaseT = t.type({
    extraCo2TypeId: t.string,
    value: decimal,
});
export const CargoExtraCo2T = t.intersection([
    CargoExtraCo2BaseT,
    t.type({ id: t.string, cargoId: t.string }),
]);
//# sourceMappingURL=cargo-extra-co2.js.map